module.exports = __webpack_public_path__ + "static/media/Manual_sencer_EN-29a.24861cab.png";